let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bHrk6")).then(() => parcelRequire('dVNj1'));